import * as XLSX from 'xlsx'

/**
 * Table export utilities for chat table data.
 * Supports CSV, Excel (.xlsx), and JSON formats.
 */
export const extractTableData = (table: HTMLTableElement) => {
  const headers: string[] = []
  const rows: string[][] = []

  const headerCells = table.querySelectorAll('thead th')
  headerCells.forEach((cell: any) => headers.push(cell.innerText.trim()))

  const bodyRows = table.querySelectorAll('tbody tr')
  bodyRows.forEach((row: any) => {
    const rowData: string[] = []
    row.querySelectorAll('td').forEach((cell: any) => rowData.push(cell.innerText.trim()))
    rows.push(rowData)
  })

  return { headers, rows }
}

const triggerDownload = (blob: Blob, filename: string) => {
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
  URL.revokeObjectURL(url)
}

export const downloadTableCSV = (table: HTMLTableElement) => {
  const { headers, rows } = extractTableData(table)
  const csvRows = [
    headers.map((h) => `"${h.replace(/"/g, '""')}"`).join(','),
    ...rows.map((row) => row.map((cell) => `"${cell.replace(/"/g, '""')}"`).join(','))
  ]
  const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8' })
  triggerDownload(blob, 'table-data.csv')
}

export const downloadTableExcel = (table: HTMLTableElement) => {
  const { headers, rows } = extractTableData(table)
  const wsData = [headers, ...rows]
  const ws = XLSX.utils.aoa_to_sheet(wsData)
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, 'Table Data')
  const wbOut = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
  const blob = new Blob([wbOut], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  })
  triggerDownload(blob, 'table-data.xlsx')
}

export const downloadTableJSON = (table: HTMLTableElement) => {
  const { headers, rows } = extractTableData(table)
  const jsonData = rows.map((row) => {
    const obj: Record<string, string> = {}
    headers.forEach((header, i) => {
      obj[header] = row[i] || ''
    })
    return obj
  })
  const blob = new Blob([JSON.stringify(jsonData, null, 2)], {
    type: 'application/json;charset=utf-8'
  })
  triggerDownload(blob, 'table-data.json')
}
